import {z} from 'zod'
import {EnvironmentName} from '../EnvironmentName.js'
import {StripeProductId} from '../../stripe/index.js'
import {EncryptionKey} from '../../encryption/index.js'

export const RecommendationRefresherEnvironmentVariables = z.object({
  ENVIRONMENT_NAME: EnvironmentName,
  COMMIT_SHA: z.string().default('unknown'),
  SENTRY_DSN: z.string(),

  ENCRYPTION_KEY: EncryptionKey,

  MONGODB_CONNECTION_STRING: z.string(),
  MONGODB_DATABASE_NAME: z.string(),
  MONGODB_USERNAME: z.string(),
  MONGODB_PASSWORD: z.string(),

  STRIPE_STARTER_SUBSCRIPTION_PRODUCT_ID: StripeProductId,
  STRIPE_BASIC_SUBSCRIPTION_PRODUCT_ID: StripeProductId,
  STRIPE_PRO_SUBSCRIPTION_PRODUCT_ID: StripeProductId,
})
export type RecommendationRefresherEnvironmentVariables = z.infer<typeof RecommendationRefresherEnvironmentVariables>
